export const APPLE_STORE_DOWNLOAD_BADGE_SRC =
  'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1606176000&h=96a5c2a193c227c97919690f1f1656f4' as const;
export const GOOGLE_PLAY_DOWNLOAD_BADGE_SRC =
  'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' as const;
export const APPLE_STORE_SCANNER_HREF =
  'https://apps.apple.com/us/app/enmon/id1538646202?itsct=apps_box_badge&amp;itscg=30200' as const;
export const GOOGLE_PLAY_SCANNER_HREF =
  'https://play.google.com/store/apps/details?id=tech.enmon.scanner2&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' as const;
